export default "/images/cart.svg?5cb34d468d6bd7d95d36cffa689ac5eb";